var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermissionSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.999,
    height: 17,
    viewBox: "0 0 19.999 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M-3799,20747h-10l-5-8.5,5-8.5h10l5,8.5-5,8.5Zm-5-12.752a4.234,4.234,0,0,0-4.212,4.248,4.236,4.236,0,0,0,4.212,4.25,4.233,4.233,0,0,0,4.207-4.25A4.232,4.232,0,0,0-3804,20734.25Z",
    transform: "translate(3814 -20730.002)",
    fill: "#9191a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionSettings);
export default __webpack_public_path__ + "static/media/permission_settings.6aa7bb3ea5c59a29cb0601dbe1bf20b2.svg";
export { ForwardRef as ReactComponent };